import { useAuthQuery } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';
import { PushApi } from 'api';
import { SearchPushQueryType } from 'types';

function useGetAll(query: SearchPushQueryType) {
  return useAuthQuery(
    getQueryKeys([KEY]).list({ ...query }),
    () => PushApi.getAll(query),
    {
      select: (data) => data.data,
    },
  );
}

export default useGetAll;
